import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { gray, themeColor } from '@whitelabel/helpers/style';
import { ReactComponent as IconAppliances } from '@whitelabel/media/icons/policies/appliances.svg';
import { ReactComponent as IconContents } from '@whitelabel/media/icons/policies/contents.svg';
import { ReactComponent as IconElectronics } from '@whitelabel/media/icons/policies/electronics.svg';
import { ReactComponent as IconFurniture } from '@whitelabel/media/icons/policies/furniture.svg';
import { ReactComponent as IconHome } from '@whitelabel/media/icons/policies/home.svg';
import { ReactComponent as IconInstruments } from '@whitelabel/media/icons/policies/instruments.svg';
import { ReactComponent as IconJewellery } from '@whitelabel/media/icons/policies/jewellery.svg';
import { ReactComponent as IconLandlord } from '@whitelabel/media/icons/policies/landlord.svg';
import { ReactComponent as IconOutdoor } from '@whitelabel/media/icons/policies/outdoor.svg';
import { ReactComponent as IconParcel } from '@whitelabel/media/icons/policies/parcel.svg';
import { ReactComponent as IconRental } from '@whitelabel/media/icons/policies/rental.svg';
import { ReactComponent as IconCOVID } from '@whitelabel/media/icons/policies/covid.svg';
import { ReactComponent as IconSports } from '@whitelabel/media/icons/policies/sports.svg';
import { ReactComponent as IconSunglasses } from '@whitelabel/media/icons/policies/sunglasses.svg';
import { ReactComponent as IconProduct } from '@whitelabel/media/icons/policies/product.svg';
import { ReactComponent as IconTrip } from '@whitelabel/media/icons/policies/trip.svg';
import { ReactComponent as IconTravel } from '@whitelabel/media/icons/policies/travel.svg';
import { ReactComponent as IconFlightDelay } from '@whitelabel/media/icons/policies/flight-delay.svg';
import { ReactComponent as IconMedical } from '@whitelabel/media/icons/policies/medical.svg';
import { ReactComponent as IconBaggage } from '@whitelabel/media/icons/policies/baggage.svg';
import { ReactComponent as IconGadget } from '@whitelabel/media/icons/policies/gadget.svg';
import { ReactComponent as IconTicket } from '@whitelabel/media/icons/policies/ticket.svg';
import { ReactComponent as IconTracker } from '@whitelabel/media/icons/policies/tracker.svg';
import { ReactComponent as IconPropertyDamage } from '@whitelabel/media/icons/policies/property-damage.svg';
import { ReactComponent as IconPet } from '@whitelabel/media/icons/policies/pet.svg';
import { ReactComponent as IconCoach } from '@whitelabel/media/icons/policies/coach.svg';
import { ReactComponent as IconRider } from '@whitelabel/media/icons/policies/rider.svg';
import { ReactComponent as IconCaravan } from '@whitelabel/media/icons/policies/caravan.svg';
import { ReactComponent as IconCyber } from '@whitelabel/media/icons/policies/cyber.svg';
import { ReactComponent as IconPublicLiability } from '@whitelabel/media/icons/policies/public_liability.svg';
import { POLICY_TYPES, POLICY_TYPE } from '../helpers/constants';

const icons = {
  [POLICY_TYPE.APPLIANCES_COVER]: IconAppliances,
  [POLICY_TYPE.ECOMMERCE_INSURANCE]: IconProduct,
  [POLICY_TYPE.ECOMMERCE_PARCEL_INSURANCE]: IconParcel,
  [POLICY_TYPE.CONTENTS_COVER]: IconContents,
  [POLICY_TYPE.CONTAINER_PROTECTION]: IconParcel,
  [POLICY_TYPE.ELECTRONICS_COVER]: IconElectronics,
  [POLICY_TYPE.FURNITURE_COVER]: IconFurniture,
  [POLICY_TYPE.HOME_COVER]: IconHome,
  [POLICY_TYPE.INSTRUMENTS_COVER]: IconInstruments,
  [POLICY_TYPE.JEWELRY_COVER]: IconJewellery,
  [POLICY_TYPE.LANDLORD_COVER]: IconLandlord,
  [POLICY_TYPE.OUTDOOR_COVER]: IconOutdoor,
  [POLICY_TYPE.PARCEL_COVER]: IconParcel,
  [POLICY_TYPE.RENTAL_COVER]: IconRental,
  [POLICY_TYPE.SPORTS_COVER]: IconSports,
  [POLICY_TYPE.SUNGLASSES_COVER]: IconSunglasses,
  [POLICY_TYPE.GADGET_COVER]: IconElectronics,
  [POLICY_TYPE.PARCEL_INSURANCE]: IconParcel,
  [POLICY_TYPE.LANDLORD_INSURANCE]: IconLandlord,
  [POLICY_TYPE.PRODUCT_INSURANCE]: IconProduct,
  [POLICY_TYPE.PRODUCT_INSURANCE_AMZN]: IconProduct,
  [POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER]: IconTrip,
  [POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER_STANDALONE]: IconTrip,
  [POLICY_TYPE.TRAVEL_FLIGHT_DELAY_COVER]: IconTravel,
  [POLICY_TYPE.TRAVEL_MEDICAL_COVER]: IconMedical,
  [POLICY_TYPE.TRAVEL_MEDICAL_COVER_STANDALONE]: IconMedical,
  [POLICY_TYPE.TRAVEL_COVID]: IconCOVID,
  [POLICY_TYPE.TRAVEL_GADGETS_ITEMS_COVER]: IconGadget,
  [POLICY_TYPE.TRAVEL_PERSONAL_BAGGAGE]: IconBaggage,
  [POLICY_TYPE.TRAVEL_PERSONAL_ELECTRONICS]: IconElectronics,
  [POLICY_TYPE.TRAVEL_INSOLVENCY_INSURANCE_UNBUNDLED]: IconTrip,
  [POLICY_TYPE.TRAVEL_FLIGHT_CANCELLATION_COVER_UNBUNDLED]: IconTrip,
  [POLICY_TYPE.TRAVEL_MEDICAL_COVER_UNBUNDLED]: IconMedical,
  [POLICY_TYPE.EVENT_TICKET_PROTECTION]: IconTicket,
  [POLICY_TYPE.COMPREHENSIVE_TRAVEL_INSURANCE]: IconTravel,
  [POLICY_TYPE.TRACKER_WARRANTY]: IconTracker,
  [POLICY_TYPE.EARTHQUAKE_COVER]: IconPropertyDamage,
  [POLICY_TYPE.TRAVEL_INSOLVENCEY_INSURANCE]: IconTrip,
  [POLICY_TYPE.PET_INSURANCE]: IconPet,
  [POLICY_TYPE.TRAVEL_COACH_PROTECTION]: IconCoach,
  [POLICY_TYPE.RIDER_INSURANCE]: IconRider,
  [POLICY_TYPE.TRAVEL_TICKET_COVER]: IconCoach,
  [POLICY_TYPE.FLIGHT_DELAY_COVER]: IconFlightDelay,
  [POLICY_TYPE.CARAVAN_PROTECTION]: IconCaravan,
  [POLICY_TYPE.RENTERS_INSURANCE]: IconRental,
  [POLICY_TYPE.CYBER_INSURANCE]: IconCyber,
  [POLICY_TYPE.BUSINESS_INSURANCE]: IconPublicLiability,
  [POLICY_TYPE.QUARANTINE_COVER]: IconCOVID,
};

// Disable eslint to keep the original logic: not pass no-unused-vars
// props down to child component.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledPolicyIcon = styled(({ type, ...props }) => <svg {...props} />).attrs(({ type }) => ({
  as: icons[type],
  'aria-hidden': 'true',
}))`
  g {
    clip-path: inherit;
  }
  ${({ color }) => {
    switch (color) {
      case 'muted':
        return css`
          .outline--stroke,
          .highlight--stroke {
            stroke: ${gray(500)};
          }

          .outline--fill,
          .highlight--fill {
            fill: ${gray(500)};
          }
        `;

      default:
        return css`
          .outline--stroke {
            stroke: ${gray(500)};
          }

          .outline--fill {
            fill: ${gray(500)};
          }

          .highlight--stroke {
            stroke: ${themeColor('primary')};
          }

          .highlight--fill {
            fill: ${themeColor('primary')};
          }
        `;
    }
  }}
`;

StyledPolicyIcon.propTypes = {
  type: PropTypes.oneOf(POLICY_TYPES).isRequired,
  color: PropTypes.oneOf(['muted']),
};

StyledPolicyIcon.defaultProps = {
  color: null,
};

export default StyledPolicyIcon;
